import { useAutoScroll } from '@/components/chat/hooks/useAutoScroll'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { ArrowDown } from 'lucide-react'
import * as React from 'react'

type ChatMessageListProps = React.ComponentProps<'div'> & {
  smooth?: boolean
}

const ChatMessageList = React.forwardRef<HTMLDivElement, ChatMessageListProps>(
  ({ className, children, smooth = false, ...props }, ref) => {
    const { scrollRef, isAtBottom, scrollToBottom, disableAutoScroll } = useAutoScroll({
      smooth,
      content: children,
    })

    return (
      <div className="h-full flex flex-col" ref={ref}>
        <div
          className={cn('flex flex-col p-2 h-full overflow-y-auto min-h-0', className)}
          ref={scrollRef}
          onWheel={disableAutoScroll}
          onTouchMove={disableAutoScroll}
          {...props}
        >
          <div className="flex flex-col gap-6">{children}</div>
        </div>

        {!isAtBottom && (
          <Button
            onClick={scrollToBottom}
            size="icon"
            variant="outline"
            elevation="floating"
            className="absolute bottom-2 left-1/2 inline-flex -translate-x-1/2 transform"
            aria-label="Scroll to bottom"
          >
            <ArrowDown className="h-4 w-4" />
          </Button>
        )}
      </div>
    )
  }
)

ChatMessageList.displayName = 'ChatMessageList'

export { ChatMessageList }
